export const getStyles = (_components, { fonts = {}, palette = {} } = {}) => {
  const color = {
    advancedTitleColor: palette.blue || '#0078D4',
  };
  const font = fonts.medium || {};

  return ({
    accordionTitle: {
      ...font,
      fontWeight: 600,
      lineHeight: '24px',
      color: color.advancedTitleColor,
      display: 'flex',

      '& .title': {
        textDecoration: 'none',

        '&:focus': {
          outline: 'none',
        },

        '&:focus-visible': {
          outline: '1px solid #000',
        },

        '&:after': {
          content: '"\\E70E"',
          float: 'left',
          fontFamily: 'MsAds MDL2 Assets',
          fontSize: '14px',
          transform: 'rotate(180deg)',
          marginRight: '11px',
        },
        '&.collapsed:after': {
          transform: 'rotate(90deg)',
          transition: 'transform .1s linear',
        },
      },

      '& .helpbutton': {
        marginLeft: 7,
      },
    },
  });
};
